<template>
  <div class="GoogleSearch">
    <div class="GoogleSearch__header">
      <span>Input: Google Search Action</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend">
      <div v-if="isValidJson" class="GoogleSearch__body">
        <div class="GoogleSearchInput__search">
          <v-icon>
            mdi-magnify
          </v-icon>
          {{ inputObject.searchQuery }}
        </div>
      </div>
      <div v-if="!isValidJson" style="padding: 10px">
        Loading
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';

export default {
  name: 'google-search-input',
  components: {},
  props: {
    input: {},
    name: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    inputObject() {
      return typeof this.input !== 'string' ? this.input : JSON.parse(this.input)
    },
    isValidJson() {
      try {
        if(typeof this.input !== 'string') {
          return true;
        }
        JSON.parse(this.input);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import './index';
</style>
